import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FeatureFlags, CustomerAccount } from '@inyova/models';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as StrategyActions from '@strategy/strategy.actions';
import * as fromApp from '@app/app.reducers';
import * as fromAppRoot from '@app/app.reducers';
import * as fromStrategy from '@strategy/reducers';

@Component({
  selector: 'app-strategy-adjust',
  templateUrl: './strategy-adjust.component.html',
  styleUrls: ['./strategy-adjust.component.scss'],
  standalone: false
})
export class StrategyAdjustComponent {
  protected readonly onDestroy$ = new Subject<void>();
  currentAccountDetail: CustomerAccount;
  editDisabled: boolean;
  backURL = '/strategy';
  productTitle = 'adjust_screen.h2';
  productType = '3b';
  isEve2 = false;

  constructor(
    private router: Router,
    private store: Store
  ) {
    this.store.pipe(select(fromApp.selectCustomerAndCurrentInvestAccount), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.currentAccountDetail = value.currentAccountDetail;

      this.productType = value.currentAccountDetail?.kind;
      switch (this.productType) {
        case '3a':
          this.productTitle = 'adjust_screen.h2-3a';
          break;
        case 'kid':
          this.productTitle = 'adjust_screen.h2-kids';
          break;
        default:
          this.productTitle = 'adjust_screen.h2';
          break;
      }
    });

    this.store.pipe(select(fromStrategy.selectChangeStrategyDisabled), takeUntil(this.onDestroy$)).subscribe((response) => {
      this.editDisabled = response;

      if (this.editDisabled) {
        void this.router.navigate([this.backURL]);
      }
    });

    this.store.pipe(select(fromAppRoot.selectAccountFeatureFlag(FeatureFlags.EVE2)), takeUntil(this.onDestroy$)).subscribe((value) => {
      this.isEve2 = value;
    });
  }

  changeStrategy(): void {
    if (this.editDisabled) {
      return;
    }
    if (this.isEve2) {
      this.store.dispatch(StrategyActions.enterStrategyEditModeEve2());
    } else {
      this.store.dispatch(StrategyActions.updateStrategyEditMode({ editMode: true }));
    }
  }

  back(): void {
    void this.router.navigate([this.backURL]);
  }
}
